<template>
    <div>
        <v-col cols="12">
            <h2>{{ t('dms-users::page.title.my_profile') }}</h2>
        </v-col>
        <v-tabs v-model="tab" show-arrows class="px-4">
            <v-tab v-for="(item, index) in items" :key="index">
                <div class="tab">
                    {{ item }}
                </div>
            </v-tab>
            <v-tab-item v-for="(item, index) in itemsContent" :key="item + index">
                <component :is="item.name"></component>
                <dms-users-form-actions v-if="item.hasActions" :my-profile="true"></dms-users-form-actions>
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
export default {
    data() {
        return {
            items: [
                t('dms-users::form.title.details'),
                t('dms-users::form.title.password'),
                t('dms-users::form.title.mfa'),
            ],
            itemsContent: [
                { name: 'dms-user-profile', hasActions: false },
                { name: 'dms-user-password', hasActions: true },
                { name: 'mfa-management-component', hasActions: false },
            ],
        };
    },
    computed: {
        tab: {
            get() {
                return this.$store.state.dms_users.tab;
            },
            set(value) {
                this.$store.dispatch('dms_users/changeTab', value);
            },
        },
    },
};
</script>
